import React from 'react'

const Navbar = () => {
  return (
    <div className='flex justify-between items-center w-full h-20 px-4 text-white bg-black fixed'>
      <div>
        <h1 className='text-5xl font-signature ml-2 text-[#E6C4BD] text-opacity-90'>FurryFun</h1>
      </div>
    </div>
  )
}

export default Navbar
